module.exports = __webpack_public_path__ + "img/tablet.1aaa46b9.png";